// src/shared/ui/components/quiet-loading.tsx
//
// The encounter's load state WITHOUT a spinner (Ahmed, 2026-10-12: "dont show the spinner in the encounter or
// pre encounter anymore"). While a surface's first read is pending, its slot stays empty and the content arrives
// through the motion its own component already plays on mount — the EncounterShell page-load stagger and step
// fade, `InternationalPatientSummary`'s `entryMotion`. No fade is added here: a second entry on top of those
// compounds the opacity and doubles the lift (DS encounter-shell-motion.css, section (d)).
//
// Used across the encounter route, and by the app's boot and session gates when the route being opened is an
// encounter, so a cold open of an encounter link draws no spinner either.
//
// It still says it is loading to assistive tech: the same `role="status"` + visually-hidden label the DS
// `BrandSpinner` carried, so a screen reader hears exactly what it heard before. `aria-busy` marks the region.
import { cn } from '@scripsteam/scrips-signal-ds';

export function QuietLoading({ label, className }: { label: string; className?: string }) {
  return (
    <div role="status" aria-live="polite" aria-busy="true" data-slot="quiet-loading" className={cn(className)}>
      <span className="sr-only">{label}</span>
    </div>
  );
}
